import { UserDaysOff } from "./UserDaysOff";
import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const DaysOff = z.object({
    daysOff: UserDaysOff.array(),
});

export type DaysOff = z.infer<typeof DaysOff>;
